<div class="modal-header">
    <h2 class="modal-title"> Change configuration</h2>
    <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="activeModal.close('CLOSE')"
    ></button>
</div>
<div class="modal-body">
    <h4 class="modal-subtitle">
        Select the component to be changed in {{ selectedEntities.length }}
        {{ selectedEntities.length > 1 | plural:
      {word: deploymentCategory.label! | lowercase, plural: deploymentCategory.labelInPlural! | lowercase}
        }}
    </h4>
    <ama-ng-configurations-accordion
            [cmpsWithConfigs]="cmpsWithConfigs"
            [entitySelected]="entitySelected"
            [(selectedConfigurations)]="selectedConfigurations"
            [redefinedConfigSuccess]="redefinedConfigSuccess"
            [editConfiguration]="editConfiguration"
            [displayDynamicForm]="displayDynamicForm">
    </ama-ng-configurations-accordion>
</div>
<div class="modal-footer">
    <button id="cancel-btn-config-modal"
            type="button"
            class="btn btn-outline-primary me-5"
            aria-label="Close"
            (click)="activeModal.close('CANCEL')">Cancel
    </button>
    <button id="save-btn-config-modal"
            type="button"
            class="btn btn-primary"
            [disabled]="!(deployedActors | availableChanges:
            selectedEntities:selectedConfigurations:deploymentCategory.level)"
            (click)="save()">Save changes
    </button>
</div>
